export default "__VITE_ASSET__27e82595__"